import {StyleSheet, css} from 'aphrodite';
import React from 'react';

import {Cell} from 'notebook/tables/constants/CellConstants';
import {EvaluatedCellError} from 'notebook/tables/excess/EvaluationConstants';
import {GRAY_SEMIDARK} from 'ui-library/Colors';

import {
  getComparisonCellDisplayText,
  MismatchErrorType,
  SimpleCellData,
  SimpleCellError,
} from './CrossModelValidation';

const MISMATCH_ERROR_TYPE_MAP: Record<MismatchErrorType, string> = {
  [MismatchErrorType.CELL_MISMATCH]: 'Cell mismatch',
  [MismatchErrorType.ROW_MISMATCH]: 'Row mismatch',
  [MismatchErrorType.USER_EDIT]: 'Info',
};

function convertToEvaluatedCellError(error: SimpleCellError): EvaluatedCellError {
  return {
    type: MISMATCH_ERROR_TYPE_MAP[error.type],
    message: error.message,
  };
}

function formatCell(cellData: SimpleCellData): Cell {
  if (cellData.error == null) {
    return {text: getComparisonCellDisplayText(cellData)};
  }

  const error = cellData.error;

  if (error.type === MismatchErrorType.CELL_MISMATCH && cellData.secondaryText != null) {
    return {
      text: getComparisonCellDisplayText(cellData),
      error: convertToEvaluatedCellError(error),
      formattedValue: (
        <span>
          <span>{cellData.primaryText}</span>
          <span className={css(styles.mismatchText)}> | {cellData.secondaryText}</span>
        </span>
      ),
    };
  }
  if (error.type === MismatchErrorType.USER_EDIT && cellData.userText != null) {
    return {
      text: cellData.userText,
      error: convertToEvaluatedCellError(error),
    };
  }
  return {
    text: cellData.primaryText,
    error: convertToEvaluatedCellError(error),
  };
}

export function formatTable(table: Array<Array<SimpleCellData>>): Array<Array<Cell>> {
  return table.map((row) => row.map((cell) => formatCell(cell)));
}

const styles = StyleSheet.create({
  mismatchText: {
    color: GRAY_SEMIDARK,
  },
});
